import { crudApi, fetchJson, headers } from './api';
import { APICustomAgentAttributes, ArdoqId } from '@ardoq/api-types';
import { isArdoqError, Result } from '@ardoq/common-helpers';
import { ApiResponse } from './types';

const customAgentCrudApi = crudApi<APICustomAgentAttributes>('custom-agent');

type ToolsetOptionsResponse = { toolsetOptions: string[] };

const fetchToolsets = (): ApiResponse<string[]> =>
  fetchJson<ToolsetOptionsResponse>(
    new Request('/api/custom-agent/toolset-options', { headers })
  ).then(
    (result): Result<string[]> =>
      isArdoqError(result) ? result : result.toolsetOptions
  );

type ModelOptionsResponse = { modelOptions: string[] };

const fetchModels = (): ApiResponse<string[]> =>
  fetchJson<ModelOptionsResponse>(
    new Request('/api/custom-agent/model-options', { headers })
  ).then(
    (result): Result<string[]> =>
      isArdoqError(result) ? result : result.modelOptions
  );

export type CustomAgentSaveInput = {
  name: string;
  humanDescription: string;
  description: string;
  instructions: string[];
  outputSchema: unknown;
  toolsets: string[];
  modelPreference: string;
  thinking: boolean;
};

export type CustomAgentIdentity = {
  _id: ArdoqId;
  _version: number;
};

const save = (
  identity: CustomAgentIdentity | null,
  input: CustomAgentSaveInput
): ApiResponse<APICustomAgentAttributes> =>
  identity
    ? customAgentCrudApi.update({ ...input, ...identity })
    : customAgentCrudApi.create(input);

export const customAgentApi = {
  ...customAgentCrudApi,
  fetchToolsets,
  fetchModels,
  save,
};
